"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentItemType = void 0;
/** Defines the types (components) that are possible for usage */
var ComponentItemType;
(function (ComponentItemType) {
    ComponentItemType["Accordion"] = "accordion";
    ComponentItemType["Teaser"] = "teaser";
    ComponentItemType["FeedbackTeaser"] = "feedback_teaser";
    ComponentItemType["Slider"] = "slider";
    ComponentItemType["Text"] = "text";
    ComponentItemType["Html"] = "html";
    ComponentItemType["ImageGroup"] = "imagegroup";
    ComponentItemType["ImageSimple"] = "image_simple";
    ComponentItemType["ImageFooter"] = "image_footer";
    ComponentItemType["Image"] = "image";
    ComponentItemType["Button"] = "button";
    ComponentItemType["Placeholder"] = "placeholder";
    ComponentItemType["Headline"] = "headline";
    ComponentItemType["RecoMagellan"] = "reco_magellan";
    ComponentItemType["RecoPrudsys"] = "reco_prudsys";
    ComponentItemType["Group"] = "group";
    ComponentItemType["List"] = "list";
    ComponentItemType["TextlinkModal"] = "textlink_modal";
    ComponentItemType["ExternalScript"] = "externalscript";
    ComponentItemType["ButtonModal"] = "buttonlink_modal";
    ComponentItemType["SvgFile"] = "svg_file";
    ComponentItemType["SectionSeperator"] = "section_seperator";
    ComponentItemType["LinkByButton"] = "link_by_button";
    ComponentItemType["LinkByText"] = "link_by_text";
    ComponentItemType["FlexibleTeaser"] = "flexible_teaser";
    ComponentItemType["DynamicYield"] = "dynamic_yield";
    ComponentItemType["FromLibrary"] = "from_library";
    ComponentItemType["Footer"] = "footer";
    ComponentItemType["FooterGroupImage"] = "footer_group_image";
    ComponentItemType["Socket"] = "socket";
    ComponentItemType["Newsletter"] = "newsletter";
    ComponentItemType["NewsletterSubscribe"] = "subscribe";
    ComponentItemType["NewsletterUnsubscribe"] = "unsubscribe";
})(ComponentItemType = exports.ComponentItemType || (exports.ComponentItemType = {}));
exports.default = ComponentItemType;
//# sourceMappingURL=SchemaTypes.js.map